module.exports = __webpack_public_path__ + "media/images/iconRight__errorRed--dark-046b851cffd952bd6424efbe85bbe967.png";